export const BUDGET_ICONS = 'How much do you love them?';
export const NO_SEARCH_RESULTS_FOR = 'There were no search results for ';
export const NO_SEARCH_RESULTS_INSTAED = "Here are today's top deals instead:";
export const FILTER_PRICE = 'Filter by price';
export const FILTER_SORT_BY = 'Sort by';
export const VIP_DISABLED_POPUP_DESC =
  'Enabling will show exclusive VIP deals and prices';
export const VIP_DISABLED_POPUP_TITLE = 'Switch on to save!';
export const VIP_ENABLED_POPUP_DESC =
  'Disabling will show a wider range of great deals!';
export const VIP_ENABLED_POPUP_TITLE = "Can't find what you're looking for?";
export const FILTER_CATEGORIES = 'Categories';
export const REFINED_RESULTS = 'Refined Results';
export const REFINE = 'Refine';
export const VIP = 'VIP';
export const VIP_SEARCH_ENABLED = 'Now showing results from all VIP deals';
export const VIP_SEARCH_DISABLED = 'Now showing results from all deals';
export const FILTER_PRICE_SHORT = 'Price';
export const DONE = 'Done';
export const CLEAR = 'Clear';
export const GIFT_BANNER_SUBTEXT = 'Find the perfect gift for your loved ones';
export const GIFT_BANNER_TITLE = 'Gift finder';
export const NEXT_BACK = {
  BACK: 'Back',
  NEXT: 'Next',
};
export const GIFT_FINDER_FILTER = {
  BUDGET: 'Budget',
  FOR: 'For',
  TYPE: 'Character',
};
export const CLEAR_YOUR_FILTERS = 'clear your filters';
export const GIFT_NO_RESULTS =
  "Oh no! We couldn't find the perfect gift for your loved ones...Please ";
export const TRY_AGAIN = ' and try again!';
export const CLEAR_ALL = 'Clear All';
export const GIFT_PERSONALITY = 'Tell us a bit more about them…';
export const GIFT_RECIPIENT = "Who's the lucky one?";
